import { render, staticRenderFns } from "./Error422.vue?vue&type=template&id=8c4a3740&"
import script from "./Error422.vue?vue&type=script&lang=js&"
export * from "./Error422.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports